import React from 'react'

const Sponser = () => {
  return (
    <div>Sponser</div>
  )
}

export default Sponser